import React, { useCallback, useEffect } from 'react'
import AppConsent from '../../components/consent/AppConsents/AppConsent'
import Form from '../../components/form/Form'
import { basicInfoForm } from '../../formDefinitions/BasicInfo/BasicInfoForm'
import MainLoader from '../../icons/MainLoader/MainLoader'

import useBasicInfoFormLogic from './hooks/useBasicInfoFormLogic'
import useFormLogic from '../../components/form/hooks/useFormLogic'
import { TFieldValuesObject } from '../../components/form/FormProps'
import { AllAdditionalFieldsNames, AllBasedFieldsNames } from '../../models/form/IFormDefinition'
import PageScreen from "../../components/organisms/Page/PageScreen";
import AppButton from '../../components/atoms/AppButton/AppButton'
import { UI_BUTTON_TYPE } from '../../components/atoms/AppButton/AppButtonProps'
import LoanOfferSummaryPanel from '../../components/organisms/LoanOfferSummaryPanel/LoanOfferSummaryPanel'



const BasicInfoForm = () => {

   const LOADING_TEXT = "Daj nam chwilę"
   const { basicInfoState, handleBasicInfoFormSubmit, isOffertReady } = useBasicInfoFormLogic()
   const { handleValidateForm } = useFormLogic()

   const handleOnBasicInfoFormSubmit = useCallback((fieldValuesObject :TFieldValuesObject<Partial<typeof AllBasedFieldsNames>> | TFieldValuesObject<Partial<typeof AllAdditionalFieldsNames>>) => {
      const result = handleValidateForm({formName: basicInfoForm.name, fieldValuesObject, formValidationFunctionsObject: basicInfoForm.formValidationFunctions})
      result && handleBasicInfoFormSubmit()
   }, [ handleBasicInfoFormSubmit, handleValidateForm ])
  

   if(!isOffertReady){ //Dopóki dane oferty do kalkulatora nie zostaną załadowane z Backendu - pokazujemy ekran ładowania.
      return <MainLoader headingText={ LOADING_TEXT } />
   }

   return (
       <PageScreen
           panel={<LoanOfferSummaryPanel loanVariant="predefined" defaultOpen={false} />}
           title={{ title: "Ruszamy!", line: true }}
           >
           <Form
               fields={basicInfoForm.fields}
               form={basicInfoForm}
               formState={basicInfoState}
               onFormSubmit={handleOnBasicInfoFormSubmit}
           >
               <AppConsent />
           </Form>

       </PageScreen>
   )
}

export default BasicInfoForm
